if (!customElements.get("m-testimonials")) {
  class MTestimonials extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.imagesTab = null;
      this.tabsInterval = null;
      this.handleBlockSelect = this.onBlockSelect.bind(this);
      this.imageSwipeArea = null;
      this.imageSwipeStartX = 0;
      this.imageSwipeStartY = 0;
      this.imageSwipeMoved = false;
      this.handleImagePointerDown = this.onImagePointerDown.bind(this);
      this.handleImagePointerUp = this.onImagePointerUp.bind(this);
      this.handleImagePointerCancel = this.onImagePointerCancel.bind(this);
      this.handleImageClick = this.onImageClick.bind(this);
    }

    connectedCallback() {
      let containerType;
      let autoplay = false;

      this.design = this.dataset.design || "";
      containerType = this.dataset.container || "container";

      if (this.dataset.autoplay) {
        autoplay = this.dataset.autoplay === "true";
      }

      this.container = this.closest(".m-testimonials");

      if (!this.design) {
        console.warn("Failed to initialize Testimonials: design not found.");
        return;
      }

      if (!this.container) {
        console.warn("Failed to initialize Testimonials: section container not found.");
        return;
      }

      this.sliderContainer = this.querySelector(".swiper-container");

      if (!this.sliderContainer) {
        this.classList.add("opacity-100");
        return;
      }

      this.defaultSettings = {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        speed: 500,
        loop: true,
        watchOverflow: true,

        pagination: {
          el: this.container.querySelector(".swiper-pagination"),
          clickable: true,
        },

        navigation: {
          nextEl: this.container.querySelector(
            ".m-slider-controls__button-next"
          ),
          prevEl: this.container.querySelector(
            ".m-slider-controls__button-prev"
          ),
        },

        autoplay: autoplay
          ? {
              delay: 5000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      };

      this.settings = {};

      let gutter = 400;

      switch (this.design) {
        case "testimonials-1":
          this.settings = {
            centeredSlides: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 500,
            slideToClickedSlide: true,
            loop: true,

            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 20,
                speed: 700,
              },

              1280: {
                slidesPerView: 5,
                slidesPerGroup: 3,
                spaceBetween: 30,
              },

              2560: {
                slidesPerView: 7,
                slidesPerGroup: 3,
              },
            },
          };
          break;

        case "testimonials-2":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 500,

            breakpoints: {
              768: {
                slidesPerView: 3,
                slidesPerGroup: 3,
                spaceBetween: 30,
              },
            },
          };
          break;

        case "testimonials-3":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20,
            speed: 500,

            breakpoints: {
              768: {
                slidesPerView: containerType === "w-full" ? 3 : 2,
                spaceBetween: 30,
              },
            },
          };
          break;

        case "testimonials-4":
          if (containerType === "container-fluid") {
            gutter = 200;
          }

          if (containerType === "container") {
            gutter = 150;
          }

          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true,
            slideToClickedSlide: true,
            speed: 500,

            breakpoints: {
              768: {
                slidesPerView: 3,
                spaceBetween: parseInt(gutter / 4, 10),
              },

              992: {
                slidesPerView: 3,
                spaceBetween: gutter / 2,
              },

              1920: {
                slidesPerView: 3,
                spaceBetween: gutter,
              },
            },
          };
          break;

        case "testimonials-5":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 16,
            speed: 500,
            loop: true,
            grabCursor: true,
            autoHeight: true,
            watchOverflow: true,

            pagination: {
              el: this.container.querySelector(".swiper-pagination"),
              clickable: false,
              type: "fraction",
            },
          };
          break;

        case "testimonials-6":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 0,
            speed: 500,
            loop: true,

            pagination:
              this.dataset.paginationType === "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },

            breakpoints: {
              768: {
                slidesPerView: 2,
              },

              1366: {
                slidesPerView: containerType === "container" ? 2 : 3,
              },

              1600: {
                slidesPerView:
                  containerType === "container-fluid" ? 3 : 4,
              },
            },
          };
          break;

        case "testimonials-7":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 18,
            speed: 550,
            loop: true,
            grabCursor: true,
            watchOverflow: true,
            autoHeight: false,

            pagination: {
              el: this.container.querySelector(".swiper-pagination"),
              clickable: true,
            },

            breakpoints: {
              768: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 20,
              },

              1280: {
                slidesPerView: 2,
                slidesPerGroup: 1,
                spaceBetween: 28,
              },
            },
          };
          break;

        case "testimonials-8":
          this.settings = {
            slidesPerView: 1,
            slidesPerGroup: 1,
            speed: 500,
            loop: true,
            effect: "fade",

            fadeEffect: {
              crossFade: true,
            },

            pagination:
              this.dataset.paginationType === "fraction"
                ? {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                    type: "fraction",
                  }
                : {
                    el: this.container.querySelector(".swiper-pagination"),
                    clickable: true,
                  },
          };
          break;

        default:
          console.warn(
            `Failed to initialize Testimonials: unsupported design "${this.design}".`
          );
          return;
      }

      this.initializeTabs();
      this.initSlider();
      this.enableImageSwipe();

      document.addEventListener(
        "shopify:block:select",
        this.handleBlockSelect
      );
    }

    initializeTabs() {
      const images = this.querySelector(".m-tabs");

      if (!images) {
        return;
      }

      let attempts = 0;
      const maximumAttempts = 200;

      const createTabs = () => {
        attempts += 1;

        if (
          window.MinimogTheme &&
          typeof window.MinimogTheme.Tabs === "function"
        ) {
          this.imagesTab = new window.MinimogTheme.Tabs(images);

          if (
            this.slider &&
            typeof this.imagesTab.setActiveTab === "function"
          ) {
            this.imagesTab.setActiveTab(this.slider.realIndex || 0);
          }

          return;
        }

        if (attempts < maximumAttempts) {
          this.tabsInterval = window.setTimeout(createTabs, 50);
        } else {
          console.warn(
            "Failed to initialize testimonial image tabs."
          );
        }
      };

      createTabs();
    }

    initSlider() {
      if (
        !window.MinimogLibs ||
        typeof window.MinimogLibs.Swiper !== "function"
      ) {
        console.warn(
          "Failed to initialize Testimonials: Swiper library not found."
        );

        this.classList.add("opacity-100");
        return;
      }

      this.slider = new window.MinimogLibs.Swiper(
        this.sliderContainer,
        {
          ...this.defaultSettings,
          ...this.settings,

          on: {
            init: () => {
              this.classList.add("opacity-100");

              window.setTimeout(() => {
                window.dispatchEvent(new Event("resize"));
              }, 100);
            },
          },
        }
      );

      if (this.design === "testimonials-4") {
        this.slider.on("activeIndexChange", (swiper) => {
          const indexElement = this.querySelector(
            ".m-testimonial-index"
          );

          if (indexElement) {
            indexElement.textContent =
              Number(swiper.realIndex) + 1;
          }
        });
      }

      if (
        this.design === "testimonials-5" ||
        this.design === "testimonials-8"
      ) {
        this.slider.on("slideChange", (swiper) => {
          this.setActiveImageTab(swiper.realIndex);
        });
      }
    }

    setActiveImageTab(index) {
      if (
        !this.imagesTab ||
        typeof this.imagesTab.setActiveTab !== "function"
      ) {
        return;
      }

      this.imagesTab.setActiveTab(index);
    }

    enableImageSwipe() {
      if (this.design !== "testimonials-5" || !this.slider) {
        return;
      }

      this.imageSwipeArea = this.querySelector(".m-testimonials__tabs");

      if (!this.imageSwipeArea) {
        return;
      }

      this.imageSwipeArea.addEventListener(
        "pointerdown",
        this.handleImagePointerDown
      );
      this.imageSwipeArea.addEventListener(
        "pointerup",
        this.handleImagePointerUp
      );
      this.imageSwipeArea.addEventListener(
        "pointercancel",
        this.handleImagePointerCancel
      );
      this.imageSwipeArea.addEventListener(
        "click",
        this.handleImageClick,
        true
      );
    }

    onImagePointerDown(event) {
      if (event.pointerType === "mouse" && event.button !== 0) {
        return;
      }

      this.imageSwipeStartX = event.clientX;
      this.imageSwipeStartY = event.clientY;
      this.imageSwipeMoved = false;

      if (this.imageSwipeArea.setPointerCapture) {
        this.imageSwipeArea.setPointerCapture(event.pointerId);
      }
    }

    onImagePointerUp(event) {
      if (!this.slider) {
        return;
      }

      const distanceX = event.clientX - this.imageSwipeStartX;
      const distanceY = event.clientY - this.imageSwipeStartY;
      const horizontalSwipe = Math.abs(distanceX) > Math.abs(distanceY);

      if (horizontalSwipe && Math.abs(distanceX) >= 40) {
        this.imageSwipeMoved = true;

        if (distanceX < 0) {
          this.slider.slideNext();
        } else {
          this.slider.slidePrev();
        }
      }

      if (this.imageSwipeArea.releasePointerCapture) {
        try {
          this.imageSwipeArea.releasePointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture may already be released by the browser.
        }
      }
    }

    onImagePointerCancel() {
      this.imageSwipeMoved = false;
    }

    onImageClick(event) {
      if (!this.imageSwipeMoved) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      this.imageSwipeMoved = false;
    }

    onBlockSelect(event) {
      const block = event.target;

      if (!block || !block.dataset) {
        return;
      }

      const index = Number(block.dataset.index);

      if (!Number.isFinite(index) || !this.slider) {
        return;
      }

      if (typeof this.slider.slideToLoop === "function") {
        this.slider.slideToLoop(index);
      } else if (typeof this.slider.slideTo === "function") {
        this.slider.slideTo(index);
      }
    }

    disconnectedCallback() {
      document.removeEventListener(
        "shopify:block:select",
        this.handleBlockSelect
      );

      if (this.tabsInterval) {
        window.clearTimeout(this.tabsInterval);
        this.tabsInterval = null;
      }

      if (this.imageSwipeArea) {
        this.imageSwipeArea.removeEventListener(
          "pointerdown",
          this.handleImagePointerDown
        );
        this.imageSwipeArea.removeEventListener(
          "pointerup",
          this.handleImagePointerUp
        );
        this.imageSwipeArea.removeEventListener(
          "pointercancel",
          this.handleImagePointerCancel
        );
        this.imageSwipeArea.removeEventListener(
          "click",
          this.handleImageClick,
          true
        );
        this.imageSwipeArea = null;
      }

      if (
        this.slider &&
        typeof this.slider.destroy === "function"
      ) {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }
  }

  customElements.define("m-testimonials", MTestimonials);
}
